import React, { Component } from 'react';
import * as _ from 'lodash';
import { AgGridReact } from '@ag-grid-community/react';
import PropTypes from 'prop-types';
import * as enums from '../../../HelperMethods/enums';
import AgGridContainer from '../../common/AgGridContainer';
import {
  GRID_OPTIONS,
  TASK_TABLE_COLUMN_MAP,
  DEFAULT_LINKED_TASK_LIST_TABLE_COLUMN_ORDER,
  TASK_VIEW_TASK_GRID_OPTIONS,
} from '../../../HelperMethods/AgGridConstants';

class BulkEditTaskList extends Component {
  getColumnDefs = () => {
    const columnOrder = DEFAULT_LINKED_TASK_LIST_TABLE_COLUMN_ORDER;

    const clonedColumnsMap = _.cloneDeep(TASK_TABLE_COLUMN_MAP);
    const columnDefs = columnOrder
      .filter((key) => key !== 'actionButtons')
      .map((columnKey) => clonedColumnsMap[columnKey]);
    return {
      columnDefs,
    };
  };

  setRowStyle = (params) => {
    if (params.data.priority === enums.TASK_PRIORITY.CRITICAL.text) {
      return { color: 'white', background: enums.TASK_PRIORITY.CRITICAL.backgroundColor };
    }
    return { background: params.data.isMultipleAssignee ? '#fffbe0' : 'inherit' };
  };

  render() {
    const { selectedTasks: tasksProp } = this.props;
    const tasksToBeRendered = tasksProp;
    const { columnDefs } = this.getColumnDefs();
    return (
      <AgGridContainer numberOfRow={(tasksToBeRendered && tasksToBeRendered.length) || 0}>
        <div className="ag-theme-balham" style={{ height: '100%' }}>
          <AgGridReact
            {...GRID_OPTIONS}
            {...TASK_VIEW_TASK_GRID_OPTIONS}
            statusBar={{
              statusPanels: [
                {
                  statusPanel: 'agTotalAndFilteredRowCountComponent',
                  align: 'left',
                },
              ],
            }}
            columnDefs={columnDefs}
            rowData={tasksToBeRendered}
            onRowDataChanged={(params) => {
              params.columnApi.autoSizeAllColumns();
            }}
            getRowStyle={this.setRowStyle}
            suppressRowClickSelection="true"
            suppressColumnVirtualisation
          />
        </div>
      </AgGridContainer>
    );
  }
}

BulkEditTaskList.propTypes = {
  selectedTasks: PropTypes.array.isRequired,
};

export default BulkEditTaskList;
